// components-js
import Amount from './Amount';
import PadEditor from '../PadEditor';
// utils
import _ from 'lodash';
import { codeGeneretor } from 'app/utils';
// config
import { TYPE } from 'app/config/prescription_content.js';
import { ITEM } from 'app/config/prescription_item.js';
import { PAD_ITEM_TYPE } from 'app/config/pad_item.js';
import { CALENDAR_TYPE } from 'app/config/calendar_type.js';

/**
 * represents an instance of PadItemMatMed
 * @class PadItemMatMed
 * @extends PadEditor
 */
export default class PadItemMatMed extends PadEditor {
  // eslint-disable-next-line
  constructor(state) {
    super(state);
  }

  prepare(currentPadItemMatMeds = [], previousPadItemMatMeds = [] /* , padDetails */) {
    this._currentData = _.cloneDeep(currentPadItemMatMeds.map(prepareAuxFn));
    this._loadedData = _.cloneDeep(previousPadItemMatMeds.map(prepareAuxFn));
    this._screenData = _.cloneDeep(this._state.data.screen);

    return this;
  }

  update(padPrescriptions, padDetails) {
    let newScreenData = [];

    // eslint-disable-next-line no-unused-vars
    for (const padPrescription of padPrescriptions) {
      const {
        prescriptionTypeForm,
        medicamentForm,
        dietForm,
        procedureForm,
        procedureKitForm,
        ...rest
        //
      } = padPrescription;

      const isPadPrescriptionTypeSuspended = padPrescription.type === TYPE.SUSPENDED;
      const isPadPrescriptionTypeInactive = padPrescription.status === 0;

      // UM PAD PRESCRIÇÃO DO TIPO SUSPENSO NÃO É CONSIDERADO PARA CALCULAR PAD ITEM
      if (isPadPrescriptionTypeSuspended) {
        continue;
      }
      // UM PAD PRESCRIÇÃO DESATIVADO NÃO É CONSIDERADO PARA CALCULAR PAD ITEM
      if (isPadPrescriptionTypeInactive) {
        continue;
      }

      // IDENTIFICA SE É UM PAD PRESCRIÇÃO DE MEDICAMENTO, DIETA OU PROCEDIMENTO
      const isPadPrescriptionDiet = prescriptionTypeForm.prescriptionType === ITEM.DIET;
      const isPadPrescriptionMedicament = prescriptionTypeForm.prescriptionType === ITEM.MEDICAMENT;
      const isPadPrescriptionProcedure = prescriptionTypeForm.prescriptionType === ITEM.PROCEDURE;

      // CRIA O FORMULÁRIO DE PRESCRIÇÃO
      const { medicament, diet /* , procedure */ } = prescriptionTypeForm.formAddOn;
      const { medicamentId, dietId /* , procedureId */ } = prescriptionTypeForm;

      let itemId;
      let prescriptionForm;
      let name;

      if (isPadPrescriptionMedicament) {
        itemId = medicamentId;
        name = medicament.name;
        prescriptionForm = { ...prescriptionTypeForm, ...medicamentForm, ...rest };

        newScreenData = this._buildNewScreenData(
          { itemId, name, prescriptionForm, padDetails },
          _.cloneDeep(newScreenData)
        );
      } else if (isPadPrescriptionDiet) {
        itemId = dietId;
        name = diet.name;
        prescriptionForm = { ...prescriptionTypeForm, ...dietForm, ...rest };

        newScreenData = this._buildNewScreenData(
          { itemId, name, prescriptionForm, padDetails },
          _.cloneDeep(newScreenData)
        );
      } else if (isPadPrescriptionProcedure) {
        const { padPrescriptionMatMeds } = procedureKitForm;

        // eslint-disable-next-line no-unused-vars
        for (const padPrescriptionMatMed of padPrescriptionMatMeds) {
          const dose = padPrescriptionMatMed.quantity;
          itemId = padPrescriptionMatMed.matMedId;
          name = padPrescriptionMatMed.name;
          prescriptionForm = { ...prescriptionTypeForm, ...procedureForm, dose, ...rest };

          newScreenData = this._buildNewScreenData(
            { itemId, name, prescriptionForm, padDetails },
            _.cloneDeep(newScreenData)
          );
        }
      } else {
        throw Error('Erro inesperado. Procurar suporte.');
      }
    }

    this._screenData = [...newScreenData];

    return this;
  }

  _buildNewScreenData({ itemId, name, prescriptionForm, padDetails }, newScreenData) {
    // REALIZA O CÁCULO DO AMOUNT
    const amount = this._calculateAmount(prescriptionForm, padDetails);

    // IDENTIFICA O PAD ITEM NO NOVO ARRAY DE PAD ITEMS A SER SUBSTITUÍDO
    const padInNewScreenData = newScreenData.find(padInNewScreenData => {
      return padInNewScreenData.itemId === itemId;
    });

    // SE O ITEM_ID EXISTIR NO NOVO ARRAY DE PAD ITEMS A SER SUBSTITUÍDO
    if (padInNewScreenData) {
      newScreenData = [...newScreenData].map(padItem => {
        const isSamePadItem = padItem.itemId === padInNewScreenData.itemId;

        if (!isSamePadItem) return { ...padItem };

        return { ...padItem, amount: padItem.amount + amount };
      });
    }

    // SE O ITEM_ID NÃO EXISTIR NO NOVO ARRAY DE PAD ITEMS A SER SUBSTITUÍDO
    if (!padInNewScreenData) {
      const padItem = prepareAuxFn({
        type: PAD_ITEM_TYPE.MAT_MED,
        itemId,
        amount,
        name
      });

      newScreenData.push(padItem);
    }

    return newScreenData;
  }

  _calculateAmount(padPrescriptionForm, padDetails) {
    const calendarType = padPrescriptionForm.calendarType || CALENDAR_TYPE.EVERY;
    const amountEntity = new Amount(calendarType, padDetails);

    const amount = amountEntity.calculate({ ...padPrescriptionForm }, padDetails);

    return amount;
  }
}

const prepareAuxFn = padItem => {
  return {
    id: padItem.id,
    code: padItem.code || codeGeneretor(),
    padType: TYPE.SUSPEINED,
    type: padItem.type,
    itemId: padItem.itemId,
    amount: padItem.amount,
    name: padItem.name
  };
};
